<template>
  <b-container id="analytics-loader" fluid title="Aguardando Google Analytics"
    style="height: 408px; text-align: center"
    class="vld-parent white-box">
    <loading active loader="bars" color="#F7BC95" :is-full-page="false"/>
  </b-container>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  mounted() {
    document.querySelector("#analytics-loader > div > div.vld-background").classList.add('ga-background')
    document.querySelector('#analytics-loader > div > div.vld-icon').classList.add('ga-icon-offset')
  },
  components: {
    Loading
  }
}
</script>

<style>

</style>
